
const LocalizedStrings = {
    'fi-FI': {
        'login.missing.credentials.header': 'Puuttuvatko tunnukset?',
        'login.missing.credentials': 'Mikäli sinulla ei ole vielä tunnusta, voit pyytää luomaan tunnuksen lähettämällä sähköpostia osoitteeseen office(at)serty.fi.',
        'login.loginbutton': 'Kirjaudu sisään ',
        'desktop.logout': 'Kirjaudu ulos ',
        'info.privacystatement': 'Tietosuojaseloste',
        'info.version': 'Versio: ',
        'error.noUser': 'Käyttäjää ei löydy',
        'error.noUser.info': 'Ole hyvä, kirjaudu sisään uudelleen. Jos ongelma toistuu, ole hyvä ja raportoi ongelma järjestelmän ylläpitäjälle.',
        'error.noContent': 'Etsimääsi sisältöä ei löytynyt!',
        'error.noContent.info': 'Hakemaasi sivua ei löytynyt. Sivu on saatettu poistaa tai siirtää toiseen osoitteeseen.',
        'error.errorID.1': 'Sisäinen palvelinvirhe',
        'error.errorID.2': 'Virheellinen tunnistautuminen',
        'error.errorID.3': 'Virheellinen rooli tai yritys',
        'error.companies.archive': 'Yrityksen arkistointi epäonnistui',
        'error.companies.add': 'Yrityksen lisääminen epäonnistui',
        'error.companies.modify': 'Yrityksen muokkaus epäonnistui',
        'error.companies.fetch': 'Yrityksen tietojen haku epäonnistui',
        'error.users.add': 'Käyttäjän lisääminen epäonnistui',
        'error.users.modify': 'Käyttäjän muokkaus epäonnistui',
        'error.users.archive': 'Käyttäjän arkistointi epäonnistui',
        'error.users.fetch': 'Käyttäjän tietojen haku epäonnistui',
        'error.reports.fetch': 'Raportin haku epäonnistui',
        'error.reports.save': 'Raportin tallennus epäonnistui',
        'error.reports.confirm': 'Raportin vahvistus epäonnistui',
        'error.bookkeeping.fetch': 'Laskutustietojen haku epäonnistui',
        'error.bookkeeping.generate': 'Laskutustietojen muodostus epäonnistui',
        'error.bookkeeping.send': 'Laskutustietojen lähetys epäonnistui',
        'error.bookkeeping.load': 'Laskutustietojen lataus epäonnistui',
        'error.settings.fetch': 'Asetuksien haku epäonnistui',
        'error.terms.fetch': 'Tietojen haku epäonnistui',
        'error.log.fetch': 'Tapahtumien haku epäonnistui',
        'error.ongoing.sent': 'Muistutusten lähettäminen epäonnistui',
        'error.messages.fetch': 'Viestipohjien haku epäonnistui',
        'error.messages.save': 'Viestipohjien tallennus epäonnistui',
        'error.categories.fetch': 'Tuoteryhmien haku epäonnistui',
        'error.categories.save': 'Tuoteryhmän tallennus epäonnistui',
        'error.categories.add': 'Tuoteryhmän lisäys epäonnistui',
        'error.subcategories.add': 'Alakategorian lisäys epäonnistui',
        'error.infotexts.fetch': 'Ohjetekstien haku epäonnistui',
        'error.infotexts.save': 'Ohjetekstien tallennus epäonnistui',
        'profile.userinfo': 'Käyttäjätiedot',
        'profile.lastvisited': 'Vieraili viimeksi:',
        'profile.name': 'Nimi',
        'profile.email': 'Sähköposti',
        'profile.role': 'Rooli',
        'profile.phone': 'Puhelinnumero',
        'profile.defaultlanguage': 'Tiedotteiden kieli',
        'language.finnish': 'Suomi',
        'language.swedish': 'Svenska',
        'language.english': 'English',
        'language.menu.toggle': 'Näytä tai piilota kielivalikko',
        'language.menu': 'Kielivalikko',
        'breadcrumb': 'Murupolku',
        'links': 'Tärkeitä linkkejä',
        'checkbox.select': 'Valitse rivi',
        'section.toolbar': 'Osion työkalupalkki',
        'unit.pieces': 'kpl',
        'button.to.desktop': 'Siirry etusivulle',
        'button.expandall': 'Avaa osiot',
        'button.collapseall': 'Sulje osiot',
        'button.back': 'Peruuta',
        'button.close': 'Sulje',
        'button.save': 'Tallenna',
        'button.fetch': 'Hae',
        'button.remove': 'Poista',
        'button.add': 'Lisää',
        'button.archive': 'Arkistoi',
        'button.activate': 'Aktivoi',
        'button.saving': '...',
        'button.report.edit': 'Muokkaa raporttia',
        'button.report.save': 'Tallenna raportti',
        'button.report.confirm': 'Vahvista raportti',
        'button.report.download': 'Lataa',
        'button.open.calendar': 'Avaa kalenteri',
        'button.change.company': 'Vaihda yritys',
        'calendar.select.month': 'Valitse kuukausi',
        'calendar.select.start': 'Aloitus',
        'calendar.select.end': 'Lopetus',
        'profile.usercompanies': 'Käyttäjään liitetyt yritykset',
        'profile.userhistory': 'Käyttäjähistoria',
        'login.loggedinuser': 'Kirjautunut käyttäjä:',
        'user.status.nocompany': 'Käyttäjään ei ole liitetty yrityksiä',
        'user.status.noreport': 'Raportti puuttuu',
        'roles.Numerus.Admin': 'Järjestelmänvalvoja',
        'roles.Numerus.SertyReporter': 'Raportoija (Serty)',
        'roles.Numerus.GuestReporter': 'Raportoija',
        'roles.Admin': 'Järjestelmänvalvoja',
        'roles.SertyReporter': 'Raportoija (Serty)',
        'roles.GuestReporter': 'Raportoija',
        'eventlog.title': 'Tapahtumahistoria',
        'eventlog.header': 'Tapahtumaloki',
        'eventlog.date': 'Päiväys',
        'eventlog.reporting': 'Raportointi',
        'eventlog.all': 'Kaikki',
        'eventlog.user': 'Käyttäjä',
        'eventlog.company': 'Yritys',
        'eventlog.type': 'Tyyppi',
        'eventlog.event': 'Tapahtuma',
        'eventlog.info': 'Info',
        'eventlog.reporting.arialabel': 'Kaikki raportointitapahtumat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'eventlog.all.arialabel': 'Kaikki tapahtumat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'eventlog.user.arialabel': 'Kaikki käyttäjätapahtumat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'eventlog.company.arialabel': 'Kaikki yritystapahtumat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'file.export': 'Vie tiedostoon',
        'menu.main': 'Päävalikko',
        'menu.login': 'Kirjautumissivu',
        'menu.home': 'Työpöytä',
        'menu.usermanagement': 'Käyttäjähallinta',
        'menu.companymanagement': 'Yrityshallinta',
        'menu.reports': 'Raportit',
        'menu.report.company': 'Yritysraportti',
        'menu.bookkeeping': 'Kirjanpito',
        'menu.categories': 'Tuoteryhmät',
        'menu.messages': 'Viestihistoria',
        'menu.languages': 'Kieliversiot',
        'menu.settings': 'Asetukset',
        'menu.user': 'Käyttäjä',
        'menu.company': 'Yritys',
        'menu.errorpage': 'Virhesivu',
        'menu.profile': 'Käyttäjän omat tiedot',
        'menu.profile.companyinfo': 'Yritystiedot',
        'languages.title': 'Kieliversiot',
        'languages.info': 'Ylläpidä tekstien sisältöjä',
        'languages.templates': 'Viestipohjat',
        'languages.templates.usage': 'Viestipohjissa käytetyt tunnisteet',
        'languages.templates.period': '- raportointikausi: ',
        'languages.templates.company': '- yritys: ',
        'languages.templates.deadline': '- raportoinnin määräaika: ',
        'languages.infos': 'Ohjetekstit',
        'languages.templates.confirm': 'Raportti vastaanotettu',
        'languages.templates.reminder': 'Muistutus',
        'languages.templates.reminder2': 'Ylimääräinen muistutus',
        'languages.templates.periodOpen': 'Kausi avattu',
        'languages.finnish': 'Suomi',
        'languages.swedish': 'Ruotsi',
        'languages.english': 'Englanti',
        'languages.message.title': 'Viestin otsikko',
        'languages.message.content': 'Viestin sisältö',
        'languages.message.saved': 'Viestipohja tallennettu',
        'languages.infotext.saved': 'Ohjeteksti tallennettu',
        'languages.infotext.content': 'Teksti',
        'languages.infotexts.usage': 'Sivujen ohjetekstit',
        'languages.infotexts.login.info.header': 'Sisäänkirjautumissivun tervehdyksen otsikko',
        'languages.infotexts.login.info': 'Sisäänkirjautumissivun tervehdys',
        'languages.infotexts.company.info': 'Yritystietojen ohje',
        'report.header': 'Kuukausiraportti',
        'report.header.info': 'SE-laitteiden maahantuontimäärien raportointi',
        'report.header.confirm.text': 'Ole hyvä ja tarkista tekemäsi muutokset ja lähetä vahvistettu raportti.',
        'report.header.confirm': 'Lähetä vahvistettu raportti',
        'report.header.reporter': 'Raportoija',
        'report.header.modified': 'Viimeksi muokattu',
        'report.header.period': 'Kausi',
        'report.details.open': 'Avaa osiot',
        'report.details.close': 'Sulje osiot',
        'report.details.sum': 'Yhteensä',
        'report.reference': 'Toimittajan viite',
        'report.saved': 'Raportin tiedot tallennettu',
        'report.saved.info': 'tallensi raportin tiedot. Vahvista raportti!',
        'report.confirmed': 'Raportin tiedot vahvistettu',
        'report.confirmed.info': 'vahvisti raportin tiedot',
        'report.header.pricegroup': 'Hintaryhmä',
        'report.header.price': 'Hinta',
        'report.header.fin': 'Manner-Suomi',
        'report.header.aland': 'Ahvenanmaa',
        'report.header.b2b': 'B2B',
        'report.header.fin.kg': 'Manner-Suomi (kg)',
        'report.header.fin.pc': 'Manner-Suomi (kpl)',
        'report.header.aland.kg': 'Ahvenanmaa (kg)',
        'report.header.aland.pc': 'Ahvenanmaa (kpl)',
        'report.header.b2b.kg': 'B2B (kg)',
        'report.header.b2b.pc': 'B2B (kpl)',
        'report.header.sum': 'Summa (€)',
        'report.format.info': 'Syötä luvut muodossa 12 345,67 (desimaalierottimena pilkku). Kenttä muokkautuu automaattisesti oikeaan muotoon. ',
        'reports.reports': 'Raportit',
        'reports.allreports': 'Kaikki raportit',
        'reports.reportstatus': 'Raportointitilanne',
        'reports.status': 'Tilanne',
        'reports.lists': 'Listat',
        'reports.periods': 'Kaudet',
        'reports.reportedpom': 'Tuotekategoriaan raportoidut POM määrät',
        'reports.companies': 'Yritykset',
        'reports.ongoing': 'Keskeneräiset',
        'reports.company': 'Yritys',
        'reports.sum': 'Summa',
        'reports.modified': 'Muokkaustiedot',
        'reports.statusinfo': 'Yrityksen raportointitilanne. Raporttia voi muokata 25. päivään saakka.',
        'reports.currentperiod': 'Kuluvan kauden raportointi: ',
        'reports.state': 'Tila',
        'reports.openreport': 'Avaa raportti',
        'reports.addreport': 'Lisää raportti',
        'reports.period': 'Kausi',
        'reports.periodView': 'Kausi',
        'reports.interval': 'kuukautta',
        'reports.intervalShort': 'kk',
        'reports.deadline': 'Takaraja',
        'reports.lastmodified': 'Viimeksi muokattu',
        'reports.actions': 'Toiminnot',
        'reports.count.bookkeeping': '{start} - {end} / {total} raporttia',
        'reports.count.companies': '{start} - {end} / {total} yritystä',
        'reports.count.users': '{start} - {end} / {total} käyttäjää',
        'reports.count.reports': '{start} - {end} / {total} raporttia',
        'reports.count.eventlog': '{start} - {end} / {total} riviä',
        'reports.count.ongoing': '{start} - {end} / {total} raporttia',
        'reports.count.reportedpom': '{start} - {end} / {total} raporttia',
        'reports.countonpage': 'kpl / sivu',
        'reports.firstpage': 'Ensimmäinen',
        'reports.lastpage': 'Viimeinen',
        'reports.nextpage': 'Seuraava',
        'reports.previouspage': 'Edellinen',
        'reports.confirmreport': 'Vahvista raportti',
        'reports.obligatory.info': 'Pakollinen tieto',
        'reports.subcategory.show.info': 'Avaa lisätiedot',
        'reportstatus.NEW': 'Aloittamatta',
        'reportstatus.OVERDUE': 'Myöhässä',
        'reportstatus.EDITING': 'Muokattu',
        'reportstatus.ONGOING': 'Tallennettu',
        'reportstatus.CONFIRMED': 'Vahvistettu',
        'reportstatus.CLOSED': 'Suljettu',
        'reportstatus.CORRECTED': 'Korjattu',
        'reportstatus.REOPENED': 'Korjattavana',
        'reportstatus.BILLED': 'Laskutettu',
        'reportstatus.REBILLED': 'Hyvityslaskutettu',
        'reportstatus.MISSING': 'Ei raportoitavaa',
        'reportedpom.statusinfo': 'Valitulla kausivälillä hintaryhmään raportoidut POM-määrät yrityksittäin.',
        'button.reportedpom.download': 'Lataa',
        'reportedpom.name': 'Yritys',
        'reportedpom.period': 'Kausi',
        'reportedpom.unit': 'Yksikkö',
        'reportedpom.total_fin': 'Manner-Suomi',
        'reportedpom.total_aland': 'Ahvenanmaa',
        'reportedpom.total_b2b': 'B2B',
        'reportedpom.total': 'Yhteensä',
        'reportedpom.total_fin_pcs': 'Manner-Suomi (kpl)',
        'reportedpom.total_fin_kg': 'Manner-Suomi (kg)',
        'reportedpom.total_aland_pcs': 'Ahvenanmaa (kpl)',
        'reportedpom.total_aland_kg': 'Ahvenanmaa (kg)',
        'reportedpom.total_b2b_pcs': 'B2B (kpl)',
        'reportedpom.total_b2b_kg': 'B2B (kg)',
        'reportedpom.total_pcs': 'Yhteensä (kpl)',
        'reportedpom.total_kg': 'Yhteensä (kg)',
        'billingstatus.NEW': 'Odottaa',
        'billingstatus.EDITING': 'Odottaa',
        'billingstatus.ONGOING': 'Odottaa',
        'billingstatus.CONFIRMED': 'Odottaa',
        'billingstatus.CLOSED': 'Odottaa',
        'billingstatus.CORRECTED': 'Odottaa',
        'billingstatus.REOPENED': 'Odottaa',
        'billingstatus.BILLED': 'Laskutettu',
        'billingstatus.REBILLED': 'Laskutettu',
        'billingstatus.invoice.corrected': 'Korjaus',
        'billingstatus.invoice.refund': 'Hyvitys',
        'billingstatus.invoice.consolidated': 'Koonti ({index}/{count})',
        'bookkeeping.bookkeeping': 'Kirjanpito',
        'bookkeeping.statusinfo': 'Lataa laskutustiedot',
        'bookkeeping.select': 'Valitse',
        'bookkeeping.company': 'Yritys',
        'bookkeeping.period': 'Kausi',
        'bookkeeping.periodView': 'Kausi',
        'bookkeeping.state': 'Tila',
        'bookkeeping.sum': 'Summa',
        'bookkeeping.billed': 'Laskutus',
        'bookkeeping.actions': 'Toiminnot',
        'bookkeeping.currentperiod': 'Uudet raportit',
        'bookkeeping.corrected': 'Korjatut', 
        'bookkeeping.unbilled': 'Laskuttamattomat', 
        'bookkeeping.sent': 'Lähetetty kirjanpitoon',
        'bookkeeping.currentperiod.arialabel': 'Kaikki kuluvan kauden raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'bookkeeping.corrected.arialabel': 'Kaikki korjatut raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'bookkeeping.unbilled.arialabel': 'Kaikki laskuttamattomat raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'bookkeeping.sent.arialabel': 'Kaikki kirjanpitoon lähetetyt raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'bookkeeping.confirm.send.invoices': 'Laskujen lähetys ja hyväksyntä voi kestää useita minuutteja. Vahvista laskujen lähetys.',
        'bookkeeping.confirm.send.invoices.title': 'Laskujen lähetyksen vahvistus',
        'button.bookkeeping.send': 'Lähetä kirjanpitoon (csv)',
        'button.bookkeeping.send.netvisor': 'Lähetä kirjanpitoon (NetVisor)',
        'button.bookkeeping.download': 'Lataa (csv)',
        'button.bookkeeping.download.netvisor': 'Lataa (NetVisor)',
        'bookkeeping.selected.count': '{count} raporttia valittuna',
        'bookkeeping.select.all': 'Valitse kaikki',
        'bookkeeping.invoices.sent.info': '{count} kpl laskuja lähetetty kirjanpitoon',
        'tablefilters.arialabel': 'Taulukon suodattimet ja yhteenveto',
        'users.title': 'Käyttäjähallinta',
        'users.title.info': 'Ylläpidä käyttäjien tietoja',
        'users.adduser': ' Lisää käyttäjä',
        'users.title.user': 'Käyttäjä - ',
        'users.modifyuser': 'Muokkaa',
        'users.archiveuser': 'Arkistoi',
        'users.activateuser': 'Aktivoi',
        'users.name': 'Nimi',
        'users.email': 'Sähköposti',
        'users.phone': 'Puhelinnumero',
        'users.companies': 'Yritykset',
        'users.reporting': 'Raportit',
        'users.language': 'Kieli',
        'users.info': 'Tiedotteet',
        'users.state': 'Tila',
        'users.actions': 'Toiminnot',
        'users.active': 'Aktiivinen',
        'users.archived': 'Arkistoitu',
        'users.activeusers': 'Aktiiviset käyttäjät',
        'users.reportingusers': 'Raportoijat',
        'users.infousers': 'Tiedotteiden saajat',
        'users.archivedusers': 'Arkistoidut',
        'users.activeusers.arialabel': 'Kaikki aktiiviset käyttäjät, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'users.reportingusers.arialabel': 'Kaikki raportoijat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'users.infousers.arialabel': 'Kaikki tiedotteiden saajat, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'users.archivedusers.arialabel': 'Kaikki arkistoidut käyttäjät, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'users.addUser.info': 'Ole hyvä ja tallenna käyttäjän tiedot ennen yrityksen lisäämistä.',
        'users.saved': 'Tiedot tallennettu',
        'users.fail.info': 'Tarkista lomakkeen tiedot.',
        'users.obligatory.info': 'Pakollinen tieto',
        'users.email.error': 'Sähköpostiosoite on jo rekisteröity käytäjälle',
        'users.addcompany': 'Lisää yritys',
        'users.pickcompany': 'Valitse yritys...',
        'users.findcompany': 'Etsi yritys',
        'users.companiestoadd': 'Lisättävät yritykset',
        'users.search.text': 'Etsi käyttäjän nimellä tai sähköpostilla',
        'confirm.remove': 'Vahvista poisto',
        'confirm.remove.content': 'Ole hyvä ja vahvista rivin poisto.',
        'confirm.archive': 'Vahvista arkistointi',
        'confirm.archive.content': 'Ole hyvä ja vahvista arkistointi.',
        'confirm.activate': 'Vahvista aktivointi',
        'confirm.activate.content': 'Ole hyvä ja vahvista aktivointi.',
        'companies.title': 'Yrityshallinta',
        'companies.title.info': 'Ylläpidä yritysten tietoja',
        'companies.search': 'Etsi',
        'companies.search.text': 'Etsi yrityksen nimellä tai y-tunnuksella',
        'companies.add': ' Lisää yritys',
        'companies.id': 'Sis.tunnus',
        'companies.name': 'Nimi',
        'companies.bid': 'Y-tunnus',
        'companies.address': 'Katuosoite',
        'companies.postal_code': 'Postinumero',
        'companies.city': 'Postitoimipaikka',
        'companies.country': 'Maa',
        'companies.phone': 'Puhelinnumero',
        'companies.www': 'www-osoite',
        'companies.archived': 'Arkistoitu',
        'companies.active': 'Aktiivinen',
        'companies.archive_period': 'Arkistointijakso',
        'companies.member': 'Jäsennumero',
        'companies.member_since': 'Liittymispäivä',
        'companies.reporting_started': 'Raportoinnin aloitus- ja lopetuskausi',
        'companies.certificate': 'Sertifikaatinnumero',
        'companies.state': 'Tila',
        'companies.users': 'Käyttäjiä',
        'companies.actions': 'Toiminnot',
        'companies.modify': 'Muokkaa',
        'companies.export.header': 'Yritykset',
        'companies.addUser.info': 'Ole hyvä ja tallenna yrityksen tiedot ennen käyttäjän lisäämistä.',
        'companies.saved': 'Tiedot tallennettu',
        'companies.fail.info': 'Tarkista lomakkeen tiedot.',
        'companies.obligatory.info': 'Pakollinen tieto',
        'companies.details': 'Yritystiedot',
        'companies.invoicing': 'Laskutustiedot',
        'companies.membership': 'Jäsentiedot',
        'companies.addedusers': 'Yritykseen liitetyt käyttäjät',
        'companies.adduser': 'Lisää käyttäjä',
        'companies.finduser': 'Etsi käyttäjä',
        'companies.userstoadd': 'Lisättävät käyttäjät',
        'companies.pickuser': 'Valitse käyttäjä...',
        'companies.contactinfo': 'Yhteystiedot',
        'companies.settings': 'Raportointiasetukset',
        'companies.reportingperiod': 'Raportointiväli',
        'companies.reportingperiod.1': 'Kuukausi',
        'companies.reportingperiod.3': 'Kvartaali',
        'companies.reportingperiod.6': '2krt/vuosi',
        'companies.reportingperiod.12': 'Vuosi',
        'companies.billingaddress': 'Laskutusosoite',
        'companies.billinglanguage': 'Laskutuksen oletuskieli',
        'companies.vatrate': 'ALV-kanta',
        'companies.vatrate.0': '0%',
        'companies.vatrate.24': '24%',
        'companies.vatrate.255': '25,5% (31.8.2024 saakka 24%)',
        'companies.paymentterm': 'Maksuaika',
        'companies.paymentterm.day': 'pv',
        'companies.reference': 'Oletusviite',
        'companies.type': 'Laskutustapa',
        'companies.type.post': 'Posti',
        'companies.type.email': 'Sähköposti',
        'companies.type.online': 'Verkkolasku',
        'companies.billingemail': 'Lasku sähköpostitse (erottele sähköpostit pilkulla)',
        'companies.onlineid': 'Verkkolaskutunnus',
        'companies.operator': 'Verkko-operaattori',
        'companies.additionalinfo': 'Lisätiedot (sisäinen)',
        'companies.inquiries': 'Tiedustelut',
        'messagelog.title': 'Viestihistoria',
        'messagelog.title.info': 'Tarkastele viestitapahtumia',
        'settings.title': 'Asetukset',
        'settings.info': 'Ylläpidä järjestelmän asetuksia',
        'settings.accountingemail': 'Laskutuksen sähköposti',
        'settings.billinglimit': 'Minimilaskutusraja',
        'settings.saved': 'Asetukset tallennettu',
        'settings.saved.failed': 'Asetusten tallennus epäonnistui',
        'settings.fail.info': 'Tarkista lomakkeen tiedot.',
        'settings.obligatory.info': 'Pakollinen tieto',
        'ongoing.select': 'Valitse',
        'ongoing.company': 'Yritys',
        'ongoing.period': 'Kausi',
        'ongoing.periodView': 'Kausi',
        'ongoing.state': 'Tila',
        'ongoing.latest': 'Viimeisin muistutus',
        'button.ongoing.send': 'Lähetä muistutus',
        'ongoing.all': 'Kaikki',
        'ongoing.current': 'Kuluva kausi',
        'ongoing.previous': 'Edellinen kausi',
        'ongoing.earlier': 'Aiemmat kaudet',
        'ongoing.all.arialabel': 'Kaikki keskeneräiset raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'ongoing.current.arialabel': 'Kaikki kuluvan kauden keskeneräiset raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'ongoing.previous.arialabel': 'Kaikki edellisen kauden keskeneräiset raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan', 
        'ongoing.earlier.arialabel': 'Kaikki aiempien kausien keskeneräiset raportit, {count} kpl, oheinen taulukko on suodatettu tämän arvon mukaan',
        'ongoing.neversent': 'Ei muistutuksia',
        'ongoing.sent': 'Lähetetty',
        'ongoing.reminders.sent.info': '{count} kpl muistutuksia lähetetty',
        'categories.title': 'Tuoteryhmät',
        'categories.title.info': 'Ylläpidä tuotetietoja',
        'categories.import.pricelist': 'Tuo hinnasto',
        'categories.add.category': 'Lisää kategoria',
        'categories.add.subcategory': 'Lisää alakategoria',
        'categories.category.code': 'Kategorian koodi',
        'categories.category.name_fi': 'FI - Kategorian nimi',
        'categories.category.name_se': 'SE - Kategorian nimi',
        'categories.category.name_en': 'EN - Kategorian nimi',
        'categories.category.price': 'Hinta',
        'categories.edit': 'Muokkaa',
        'categories.saved': 'Tiedot tallennettu',
        'categories.category': 'Kategoria',
        'categories.category.select': 'Valitse tuotekategoria',
        'categories.subcategory.title': 'Alakategoriat',
        'categories.subcategory.add': 'Lisää alakategoria',
        'categories.subcategory.modify': 'Muokkaa alakategorian tietoja',
        'categories.subcategory.code': 'Alakategorian koodi',
        'categories.subcategory.columns': 'Sarakkeet',
        'categories.subcategory.fin': 'Manner-Suomi',
        'categories.subcategory.aland': 'Ahvenanmaa',
        'categories.subcategory.b2b': 'B2B',
        'categories.subcategory.priceunit': 'Hintayksikkö',
        'categories.subcategory.pricestart': 'Aloitusaika',
        'categories.subcategory.price': 'Hinta',
        'categories.subcategory.texts': 'Alakategorian tekstit',
        'categories.subcategory.addrow': 'Lisää rivi',
        'categories.subcategory.name': 'Alakategorian nimi',
        'categories.subcategory.info': 'Ohjeteksti',
        'categories.obligatory.info': 'Pakollinen tieto',
    },
    'en-GB': {
        'login.missing.credentials.header': 'Missing credentials?',
        'login.missing.credentials': 'If you don\'t have credentials yet, you can request to create one by sending an email to the address office(at)serty.fi.',
        'login.loginbutton': 'Sign In ',
        'desktop.logout': 'Sign Out ',
        'info.privacystatement': 'Privacy statement',
        'info.version': 'Version: ',
        'error.noUser': 'User not found ',
        'error.noUser.info': 'Please sign in again. If the problem recurs, please report the problem to the system administrator.',
        'error.noContent': 'The resource requested could not be found!',
        'error.noContent.info': 'The page you were looking for was not found. The page may have been removed or moved to another address.',
        'error.errorID.1': 'Internal server error',
        'error.errorID.2': 'Invalid authentication',
        'error.errorID.3': 'Invalid role or company',
        'error.companies.archive': 'Company archieving failed',
        'error.companies.add': 'Company add failed',
        'error.companies.modify': 'Company modify failed',
        'error.companies.fetch': 'Company fetch failed',
        'error.users.add': 'User add failed',
        'error.users.modify': 'User modify failed',
        'error.users.archive': 'User arhcieving failed',
        'error.users.fetch': 'User fetch failed',
        'error.reports.fetch': 'Report fetch failed',
        'error.reports.save': 'Report save failed',
        'error.reports.confirm': 'Report confirm failed',
        'error.bookkeeping.fetch': 'Invoicing data fetch failed',
        'error.bookkeeping.generate': 'Invoicing data generation failed',
        'error.bookkeeping.send': 'Invoicing data send failed',
        'error.bookkeeping.load': 'Invoicing data load failed',
        'error.settings.fetch': 'Settings fetch failed',
        'error.terms.fetch': 'Terms fetch failed',
        'error.log.fetch': 'Log fetch failed',
        'error.ongoing.sent': 'Reminder sending failed',
        'error.messages.fetch': 'Message template fetch failed',
        'error.messages.save': 'Message template save failed',
        'error.categories.fetch': 'Categories fetch failed',
        'error.categories.save': 'Category save failed',
        'error.categories.add': 'Category add failed',
        'error.subcategories.add': 'Subcategory add failed',
        'profile.userinfo': 'User information',
        'error.infotexts.fetch': 'Instruction text fetch failed',
        'error.infotexts.save': 'Instruction text save failed',
        'profile.lastvisited': 'Last visited:',
        'profile.name': 'Name',
        'profile.email': 'Email',
        'profile.role': 'Role',
        'profile.phone': 'Phone',
        'profile.defaultlanguage': 'Language of the messages',
        'language.finnish': 'Suomi',
        'language.swedish': 'Svenska',
        'language.english': 'English',
        'language.menu.toggle': 'Show or hide language menu',
        'language.menu': 'Language menu',
        'breadcrumb': 'Breadcrumb',
        'links': 'Important links',
        'checkbox.select': 'Select row',
        'section.toolbar': 'Section toolbar',
        'unit.pieces': 'pcs',
        'button.to.desktop': 'Go to desktop',
        'button.expandall': 'Open sections',
        'button.collapseall': 'Close sections',
        'button.back': 'Cancel',
        'button.close': 'Close',
        'button.save': 'Save',
        'button.fetch': 'Fetch',
        'button.remove': 'Remove',
        'button.add': 'Add',
        'button.archive': 'Archive',
        'button.activate': 'Activate',
        'button.saving': '...',
        'button.report.edit': 'Edit report',
        'button.report.save': 'Save report',
        'button.report.confirm': 'Confirm report',
        'button.report.download': 'Download',
        'button.open.calendar': 'Open calendar',
        'button.change.company': 'Change company',
        'calendar.select.month': 'Select month',
        'calendar.select.start': 'Start',
        'calendar.select.end': 'End',
        'profile.usercompanies': 'Companies connected to the user',
        'profile.userhistory': 'User history',
        'login.loggedinuser': 'Logged in user:',
        'user.status.nocompany': 'No companies are associated with the user',
        'user.status.noreport': 'Report missing',
        'roles.Numerus.Admin': 'Administrator',
        'roles.Numerus.SertyReporter': 'Reporter (Serty)',
        'roles.Numerus.GuestReporter': 'Reporter',
        'roles.Admin': 'Administrator',
        'roles.SertyReporter': 'Reporter (Serty)',
        'roles.GuestReporter': 'Reporter',
        'eventlog.title': 'Event History',
        'eventlog.header': 'Event log',
        'eventlog.date': 'Date',
        'eventlog.reporting': 'Reporting',
        'eventlog.all': 'All',
        'eventlog.user': 'User',
        'eventlog.company': 'Company',
        'eventlog.type': 'Type',
        'eventlog.event': 'Event',
        'eventlog.info': 'Info',
        'eventlog.reporting.arialabel': 'All reporting events, {count} pcs, the related table is filtered according to this value',
        'eventlog.all.arialabel': 'All events, {count} pcs, the related table is filtered according to this value',
        'eventlog.user.arialabel': 'All user events, {count} pcs, the related table is filtered according to this value',
        'eventlog.company.arialabel': 'All company events, {count} pcs, the related table is filtered according to this value',
        'file.export': 'Export to file',
        'menu.main': 'Main navigation',
        'menu.login': 'Login page',
        'menu.home': 'Desktop',
        'menu.usermanagement': 'User management',
        'menu.companymanagement': 'Company management',
        'menu.reports': 'Reports',
        'menu.report.company': 'Company Reports',
        'menu.bookkeeping': 'Accounting',
        'menu.categories': 'Categories',
        'menu.messages': 'Message history',
        'menu.languages': 'Languages',
        'menu.settings': 'Settings',
        'menu.user': 'User',
        'menu.company': 'Company',
        'menu.errorpage': 'Error page',
        'menu.profile': 'User profile',
        'menu.profile.companyinfo': 'Company info',
        'languages.title': 'Languages',
        'languages.info': 'Maintain text contents',
        'languages.templates': 'Message templates',
        'languages.templates.usage': 'Tags used in message templates',
        'languages.templates.period': '- reporting period: ',
        'languages.templates.company': '- company: ',
        'languages.templates.deadline': '- reporting deadline: ',
        'languages.infos': 'Info texts',
        'languages.templates.confirm': 'Report received',
        'languages.templates.reminder': 'Reminder',
        'languages.templates.reminder2': 'Extra reminder',
        'languages.templates.periodOpen': 'Reporting period open',
        'languages.finnish': 'Finnish',
        'languages.swedish': 'Swedish',
        'languages.english': 'English',
        'languages.message.title': 'Message title',
        'languages.message.content': 'Message content',
        'languages.message.saved': 'Message saved',
        'languages.infotext.saved': 'Instruction text saved',
        'languages.infotext.content': 'Text',
        'languages.infotexts.usage': 'Instruction texts for pages',
        'languages.infotexts.login.info.header': 'Login greeting text header',
        'languages.infotexts.login.info': 'Login greeting text',
        'languages.infotexts.company.info': 'Company information guide',
        'report.header': 'Report',
        'report.header.info': 'Reporting of electric and electrical equipment your company has put on the market of continental Finland and Åland',
        'report.header.confirm.text': 'Please review your changes and send the confirmed report.',
        'report.header.confirm': 'Send confirmed report',
        'report.header.reporter': 'Reporter',
        'report.header.modified': 'Last edited',
        'report.header.period': 'Period',
        'report.details.open': 'Open sections',
        'report.details.close': 'Close sections',
        'report.details.sum': 'Total',
        'report.reference': 'Reference',
        'report.saved': 'Report information saved',
        'report.saved.info': 'saved the report information. Confirm the report!',
        'report.confirmed': 'Report details confirmed',
        'report.confirmed.info': 'confirmed the report information',
        'report.header.pricegroup': 'Price group',
        'report.header.price': 'Price',
        'report.header.fin': 'Mainland Finland',
        'report.header.aland': 'Åland',
        'report.header.b2b': 'B2B',
        'report.header.fin.kg': 'Mainland Finland (kg)',
        'report.header.fin.pc': 'Mainland Finland (pcs)',
        'report.header.aland.kg': 'Åland (kg)',
        'report.header.aland.pc': 'Åland (pcs)',
        'report.header.b2b.kg': 'B2B (kg)',
        'report.header.b2b.pc': 'B2B (pcs)',
        'report.header.sum': 'Sum (€)',
        'report.format.info': 'Enter the numbers in the format 12 345,67 (comma as decimal separator). The field will automatically adjust to the correct format. ',
        'reports.reports': 'Reports',
        'reports.allreports': 'All reports',
        'reports.reportstatus': 'Report status',
        'reports.status': 'Status',
        'reports.lists': 'Lists',
        'reports.periods': 'Periods',
        'reports.reportedpom': 'POM amounts reported to product category ',
        'reports.companies': 'Companies',
        'reports.ongoing': 'Ongoing',
        'reports.company': 'Company',
        'reports.sum': 'Sum',
        'reports.modified': 'Modified',
        'reports.statusinfo': 'Reporting status. The report can be modified until the 25th of current month.',
        'reports.currentperiod': 'Reporting for the current period: ',
        'reports.state': 'State',
        'reports.openreport': 'Open report',
        'reports.addreport': 'Add report',
        'reports.period': 'Period',
        'reports.periodView': 'Periods',
        'reports.interval': 'months',
        'reports.intervalShort': 'mo',
        'reports.deadline': 'Deadline',
        'reports.lastmodified': 'Last modified',
        'reports.actions': 'Actions',
        'reports.count.bookkeeping': '{start} - {end} / {total} reports',
        'reports.count.companies': '{start} - {end} / {total} companies',
        'reports.count.users': '{start} - {end} / {total} users',
        'reports.count.reports': '{start} - {end} / {total} reports',
        'reports.count.eventlog': '{start} - {end} / {total} lines',
        'reports.count.ongoing': '{start} - {end} / {total} reports',
        'reports.count.reportedpom': '{start} - {end} / {total} reports',
        'reports.countonpage': 'pcs / page',
        'reports.firstpage': 'First',
        'reports.lastpage': 'Last',
        'reports.nextpage': 'Next',
        'reports.previouspage': 'Pervious',
        'reports.confirmreport': 'Confirm report',
        'reports.obligatory.info': 'Obligatory info',
        'reports.subcategory.show.info': 'Show additional information',
        'reportstatus.NEW': 'New',
        'reportstatus.OVERDUE': 'Overdue',
        'reportstatus.EDITING': 'Editing',
        'reportstatus.ONGOING': 'Ongoing',
        'reportstatus.CONFIRMED': 'Confirmed',
        'reportstatus.CLOSED': 'Closed',
        'reportstatus.CORRECTED': 'Corrected',
        'reportstatus.REOPENED': 'Reopened',
        'reportstatus.BILLED': 'Billed',
        'reportstatus.REBILLED': 'Rebilled',
        'reportstatus.MISSING': 'Nothing to report',
        'reportedpom.statusinfo': 'reportedpom statusinfo',
        'button.reportedpom.download': 'Download',
        'reportedpom.name': 'Company',
        'reportedpom.total_fin': 'Mainland Finland',
        'reportedpom.total_aland': 'Åland',
        'reportedpom.total_b2b': 'B2B',
        'reportedpom.total': 'Total',
        'reportedpom.period': 'Period',
        'reportedpom.unit': 'Unit',
        'reportedpom.total_pcs': 'Total (pcs)',
        'reportedpom.total_kg': 'Total (kg)',
        'reportedpom.total_fin_pcs': 'Mainland Finland (pcs)',
        'reportedpom.total_fin_kg': 'Mainland Finland (kg)',
        'reportedpom.total_aland_pcs': 'Åland (pcs)',
        'reportedpom.total_aland_kg': 'Åland (kg)',
        'reportedpom.total_b2b_pcs': 'B2B (pcs)',
        'reportedpom.total_b2b_kg': 'B2B (kg)',
        'billingstatus.NEW': 'Waiting',
        'billingstatus.EDITING': 'Waiting',
        'billingstatus.ONGOING': 'Waiting',
        'billingstatus.CONFIRMED': 'Waiting',
        'billingstatus.CLOSED': 'Waiting',
        'billingstatus.CORRECTED': 'Waiting',
        'billingstatus.REOPENED': 'Waiting',
        'billingstatus.BILLED': 'Billed',
        'billingstatus.REBILLED': 'Billed',
        'billingstatus.invoice.corrected': 'Corrected',
        'billingstatus.invoice.refund': 'Refund',
        'billingstatus.invoice.consolidated': 'Consolidated ({index}/{count})',
        'bookkeeping.bookkeeping': 'Accounting',
        'bookkeeping.statusinfo': 'Download invoicing information',
        'bookkeeping.select': 'Select',
        'bookkeeping.company': 'Company',
        'bookkeeping.period': 'Period',
        'bookkeeping.periodView': 'Period',
        'bookkeeping.state': 'State',
        'bookkeeping.sum': 'Sum',
        'bookkeeping.billed': 'Invoicing',
        'bookkeeping.actions': 'Actions',
        'bookkeeping.currentperiod': 'New reports',
        'bookkeeping.corrected': 'Corrected', 
        'bookkeeping.unbilled': 'Unbilled', 
        'bookkeeping.sent': 'Sent to accounting',
        'bookkeeping.currentperiod.arialabel': 'All reports for the current period, {count} pcs, the related table is filtered according to this value', 
        'bookkeeping.corrected.arialabel': 'All corrected reports, {count} pcs, the related table is filtered according to this value', 
        'bookkeeping.unbilled.arialabel': 'All unbilled reports, {count} pcs, the related table is filtered according to this value', 
        'bookkeeping.sent.arialabel': 'All reports sent to accounting, {count} pcs, the related table is filtered according to this value',
        'bookkeeping.confirm.send.invoices': 'Sending and processing invoices might take several minutes. Please confirm sending.',
        'bookkeeping.confirm.send.invoices.title': 'Confirm sending invoices',
        'button.bookkeeping.send': 'Send to accounting (csv)',
        'button.bookkeeping.send.netvisor': 'Send to accounting (NetVisor)',
        'button.bookkeeping.download': 'Download (csv)',
        'button.bookkeeping.download.netvisor': 'Download (NetVisor)',
        'bookkeeping.selected.count': '{count} reports selected',
        'bookkeeping.select.all': 'Select all',
        'bookkeeping.invoices.sent.info': '{count} pcs invoices sent to accounting',
        'tablefilters.arialabel': 'Table filters and summary',
        'users.title': 'User management',
        'users.title.info': 'Maintain user information',
        'users.adduser': ' Add user',
        'users.title.user': 'User - ',
        'users.modifyuser': 'Modify',
        'users.archiveuser': 'Archive',
        'users.activateuser': 'Activate',
        'users.name': 'Name',
        'users.email': 'Email',
        'users.phone': 'Phone',
        'users.companies': 'Companies',
        'users.reporting': 'Reporter',
        'users.language': 'Language',
        'users.info': 'Newsletters',
        'users.state': 'State',
        'users.actions': 'Actions',
        'users.active': 'Active',
        'users.archived': 'Archived',
        'users.activeusers': 'Active users',
        'users.reportingusers': 'Reporters',
        'users.infousers': 'Info users',
        'users.archivedusers': 'Archived',
        'users.activeusers.arialabel': 'All active users, {count} pcs, the related table is filtered according to this value',
        'users.reportingusers.arialabel': 'All reporters, {count} pcs, the related table is filtered according to this value',
        'users.infousers.arialabel': 'All receivers of the newsletters, {count} pcs, the related table is filtered according to this value',
        'users.archivedusers.arialabel': 'All archived users, {count} pcs, the related table is filtered according to this value',
        'users.addUser.info': 'Please save user information before adding a company.',
        'users.saved': 'Information saved',
        'users.fail.info': 'Check the information in the form.',
        'users.obligatory.info': 'Required information',
        'users.email.error': 'The email address is already registered for the user',
        'users.addcompany': 'Add company',
        'users.pickcompany': 'Select company...',
        'users.findcompany': 'Find company',
        'users.companiestoadd': 'Companies to add',
        'users.search.text': 'Search by name or email',
        'confirm.remove': 'Confirm remove',
        'confirm.remove.content': 'Please confirm the row deletion.',
        'confirm.archive': 'Confirm archiving',
        'confirm.archive.content': 'Please confirm the archiving.',
        'confirm.activate': 'Confirm activation',
        'confirm.activate.content': 'Please confirm the activation.',
        'companies.title': 'Company management',
        'companies.title.info': 'Maintain company information',
        'companies.search': 'Search',
        'companies.search.text': 'Search by company name or business ID',
        'companies.add': ' Add company',
        'companies.id': 'Internal id',
        'companies.name': 'Name',
        'companies.bid': 'Business ID',
        'companies.address': 'Address',
        'companies.postal_code': 'Postal code',
        'companies.city': 'City',
        'companies.country': 'Country',
        'companies.phone': 'Phone',
        'companies.www': 'Website',
        'companies.archived': 'Archived',
        'companies.active': 'Active',
        'companies.archive_period': 'Archive period',
        'companies.member': 'Membership number',
        'companies.member_since': 'Member since',
        'companies.reporting_started': 'Reporting start and end period',
        'companies.certificate': 'Certificate',
        'companies.state': 'State',
        'companies.users': 'Users',
        'companies.actions': 'Actions',
        'companies.modify': 'Modify',
        'companies.export.header': 'Companies',
        'companies.addUser.info': 'Please save the company information before adding a user.',
        'companies.saved': 'Information saved',
        'companies.fail.info': 'Check the information in the form.',
        'companies.obligatory.info': 'Required information',
        'companies.details': 'Company details',
        'companies.invoicing': 'Billing information',
        'companies.membership': 'Member information',
        'companies.addedusers': 'Users connected to the company',
        'companies.adduser': 'Add user',
        'companies.finduser': 'Find user',
        'companies.userstoadd': 'Users to add',
        'companies.pickuser': 'Select user...',
        'companies.contactinfo': 'Contact information',
        'companies.settings': 'Report settings',
        'companies.reportingperiod': 'Reporting interval',
        'companies.reportingperiod.1': 'Month',
        'companies.reportingperiod.3': 'Quarter',
        'companies.reportingperiod.6': '2 times/year',
        'companies.reportingperiod.12': 'Year',
        'companies.billingaddress': 'Billing address',
        'companies.billinglanguage': 'Billing language',
        'companies.vatrate': 'VAT rate',
        'companies.vatrate.0': '0%',
        'companies.vatrate.24': '24%',
        'companies.vatrate.255': '25,5% (24% until 31.8.2024)',
        'companies.paymentterm': 'Payment terms',
        'companies.paymentterm.day': 'day',
        'companies.reference': 'Default reference number',
        'companies.type': 'Type',
        'companies.type.post': 'Post',
        'companies.type.email': 'Email',
        'companies.type.online': 'Online',
        'companies.billingemail': 'Invoice emails (separate emails with a comma)',
        'companies.onlineid': 'Online invoice ID',
        'companies.operator': 'Operator',
        'companies.additionalinfo': 'Additional information (internal)',
        'companies.inquiries': 'Inquiries',
        'messagelog.title': 'Message history',
        'messagelog.title.info': 'View message events',
        'settings.title': 'Settings',
        'settings.info': 'Maintain system settings',
        'settings.accountingemail': 'Accounting email',
        'settings.billinglimit': 'Billing limit',
        'settings.saved': 'Settings saved',
        'settings.saved.failed': 'Saving of settings failed',
        'settings.fail.info': 'Check the information in the form.',
        'settings.obligatory.info': 'Required information',
        'ongoing.select': 'Select',
        'ongoing.company': 'Company',
        'ongoing.period': 'Period',
        'ongoing.periodView': 'Period',
        'ongoing.state': 'State',
        'ongoing.latest': 'Latest reminder',
        'button.ongoing.send': 'Send reminder',
        'ongoing.all': 'All',
        'ongoing.current': 'Current period',
        'ongoing.previous': 'Previous period',
        'ongoing.earlier': 'Earlier periods',
        'ongoing.all.arialabel': 'All not started or ongoing reports, {count} pcs, the related table is filtered according to this value', 
        'ongoing.current.arialabel': 'All not started or ongoing reports for the current period, {count} pcs, the related table is filtered according to this value', 
        'ongoing.previous.arialabel': 'All not started or ongoing reports for the previous period, {count} pcs, the related table is filtered according to this value', 
        'ongoing.earlier.arialabel': 'All not started or ongoing reports for the earlier periods, {count} pcs, the related table is filtered according to this value',
        'ongoing.neversent': 'No reminders',
        'ongoing.sent': 'Sent',
        'ongoing.reminders.sent.info': '{count} reminders sent',
        'categories.title': 'Categories',
        'categories.title.info': 'Maintain catefories',
        'categories.import.pricelist': 'Import price list',
        'categories.add.category': 'Add category',
        'categories.add.subcategory': 'Add subcategory',
        'categories.category.code': 'Category code',
        'categories.category.name_fi': 'FI - Category name',
        'categories.category.name_se': 'SE - Category name',
        'categories.category.name_en': 'EN - Category name',
        'categories.category.price': 'Price',
        'categories.edit': 'Edit',
        'categories.saved': 'Information saved',
        'categories.category': 'Category',
        'categories.category.select': 'Select category',
        'categories.subcategory.title': 'Subcategories',
        'categories.subcategory.add': 'Add subcategory',
        'categories.subcategory.modify': 'Modify subcategory information',
        'categories.subcategory.code': 'Subcategory code',
        'categories.subcategory.columns': 'Columns',
        'categories.subcategory.fin': 'Mainland Finland',
        'categories.subcategory.aland': 'Åland',
        'categories.subcategory.b2b': 'B2B',
        'categories.subcategory.priceunit': 'Price unit',
        'categories.subcategory.pricestart': 'Start time',
        'categories.subcategory.price': 'Price',
        'categories.subcategory.texts': 'Subcategory information',
        'categories.subcategory.addrow': 'Add row',
        'categories.subcategory.name': 'Subcategory name',
        'categories.subcategory.info': 'Subcategory info',
        'categories.obligatory.info': 'Required information',
    },  
    'sv-SE': {
        'login.missing.credentials.header': 'Saknas autentiseringsuppgifter?',
        'login.missing.credentials': 'Om du inte har ett ID ännu kan du skicka ett mail till adressen office(at)serty.fi.',
        'login.loginbutton': 'Logga in ',
        'desktop.logout': 'Logga ut ',
        'info.privacystatement': 'Sekretesspolicy',
        'info.version': 'Version: ',
        'error.noUser': 'Användaren hittades inte ',
        'error.noUser.info': 'Logga in igen. Om problemet återkommer, rapportera problemet till systemadministratören.',
        'error.noContent': 'Innehållet du letade efter hittades inte!',
        'error.noContent.info': 'Sidan du letade efter hittades inte. Sidan kan ha tagits bort eller flyttats till en annan adress.',
        'error.errorID.1': 'Internt serverfel',
        'error.errorID.2': 'Felaktig autentisering',
        'error.errorID.3': 'Felaktig roll eller företag',
        'error.companies.archive': 'Företagets arkivering misslyckades',
        'error.companies.add': 'Lägga till ett företag misslyckades',
        'error.companies.modify': 'Företag redigera misslyckades',
        'error.companies.fetch': 'Misslyckades med att hämta företagsinformation',
        'error.users.add': 'Det gick inte att lägga till en användare',
        'error.users.modify': 'Användarens redigering misslyckades',
        'error.users.archive': 'Användararkivering misslyckades',
        'error.users.fetch': 'Hämtning av användarinformation misslyckades',
        'error.reports.fetch': 'Misslyckades med att hämta rapporten',
        'error.reports.save': 'Misslyckades med att spara rapporten',
        'error.reports.confirm': 'Verifiering av rapport misslyckades',
        'error.bookkeeping.fetch': 'Faktureringsinformationen kunde inte hämtas',
        'error.bookkeeping.generate': 'Generering av faktureringsdata misslyckades',
        'error.bookkeeping.send': 'Misslyckades med att skicka faktureringsinformation',
        'error.bookkeeping.load': 'Nedladdning av faktureringsdata misslyckades',
        'error.settings.fetch': 'Hämtning av inställningar misslyckades',
        'error.terms.fetch': 'Misslyckades med att hämta data',
        'error.log.fetch': 'Misslyckades med att söka efter händelser',
        'error.ongoing.sent': 'Underlåtenhet att skicka påminnelser',
        'error.messages.fetch': 'Misslyckades med att hämta meddelandebaser',
        'error.messages.save': 'Misslyckades med att spara meddelandebaser',
        'error.categories.fetch': 'Sökningen efter produktgrupper misslyckades',
        'error.categories.save': 'Det gick inte att spara en produktgrupp',
        'error.categories.add': 'Infogning av produktgrupp misslyckades',
        'error.subcategories.add': 'Misslyckades med att lägga till underkategori',
        'error.infotexts.fetch': 'Misslyckades med att hämta instruktionstexter',
        'error.infotexts.save': 'Misslyckades med att spara instruktionstexter',
        'profile.userinfo': 'Användarinformation',
        'profile.lastvisited': 'Senast besökt:',
        'profile.name': 'Namn',
        'profile.email': 'E-post',
        'profile.role': 'Roll',
        'profile.phone': 'Telefonnummer',
        'profile.defaultlanguage': 'Språk för meddelanden',
        'language.finnish': 'Suomi',
        'language.swedish': 'Svenska',
        'language.english': 'English',
        'language.menu.toggle': 'Visa eller dölja språkmenyn',
        'language.menu': 'Språkmeny',
        'breadcrumb': 'Brödsmula',
        'links': 'Viktiga länkar',
        'checkbox.select': 'Välj en rad',
        'section.toolbar': 'Verktygsfält för sektioner',
        'unit.pieces': 'st',
        'button.to.desktop': 'Gå till startsidan',
        'button.expandall': 'Öppna sektioner',
        'button.collapseall': 'Nära sektioner',
        'button.back': 'Avbryt',
        'button.close': 'Nära',
        'button.save': 'Spara',
        'button.fetch': 'Hämta',
        'button.remove': 'Avlägsna',
        'button.add': 'Tillsätt',
        'button.archive': 'Arkivera',
        'button.activate': 'Aktivera',
        'button.saving': '...',
        'button.report.edit': 'Redigera rapporten',
        'button.report.save': 'Spara rapporten',
        'button.report.confirm': 'Bekräfta rapporten',
        'button.report.download': 'Ladda ner',
        'button.open.calendar': 'Öppna kalender',
        'button.change.company': 'Byt företag',
        'calendar.select.month': 'Välj månad',
        'calendar.select.start': 'Starta',
        'calendar.select.end': 'Slutet',
        'profile.usercompanies': 'Användarrelaterade företag',
        'profile.userhistory': 'Användarhistorik',
        'login.loggedinuser': 'Användare online:',
        'user.status.nocompany': 'Inga företag är associerade med användaren',
        'user.status.noreport': 'Rapportera saknad',
        'roles.Numerus.Admin': 'Administratör',
        'roles.Numerus.SertyReporter': 'Reporter (Serty)',
        'roles.Numerus.GuestReporter': 'Reporter',
        'roles.Admin': 'Administratör',
        'roles.SertyReporter': 'Reporter (Serty)',
        'roles.GuestReporter': 'Reporter',
        'eventlog.title': 'Eventhistorik',
        'eventlog.header': 'Eventlogg',
        'eventlog.date': 'Datum',
        'eventlog.reporting': 'Rapportering',
        'eventlog.all': 'Allt',
        'eventlog.user': 'Användare',
        'eventlog.company': 'Företag',
        'eventlog.type': 'Typ',
        'eventlog.event': 'Event',
        'eventlog.info': 'Info',
        'eventlog.reporting.arialabel': 'Alla rapporterande event, {count} st, tabellen nedan filtreras av detta värde',
        'eventlog.all.arialabel': 'Alla event, {count} st, tabellen nedan filtreras av detta värde',
        'eventlog.user.arialabel': 'Alla användarevent, {count} st, tabellen nedan filtreras av detta värde',
        'eventlog.company.arialabel': 'Alla företagevent, {count} st, tabellen nedan filtreras av detta värde',
        'file.export': 'Export till fil',
        'menu.main': 'Huvudmenyn',
        'menu.login': 'Inloggningssida',
        'menu.home': 'Desktop',
        'menu.usermanagement': 'Användaradministration',
        'menu.companymanagement': 'Företagsadministration',
        'menu.reports': 'Rapporter',
        'menu.report.company': 'Företagsrapport',
        'menu.bookkeeping': 'Redovisning',
        'menu.categories': 'Produktkategorier',
        'menu.messages': 'Händelsehistorik',
        'menu.languages': 'Språkversioner',
        'menu.settings': 'Inställningar',
        'menu.user': 'Användare',
        'menu.company': 'Företag',
        'menu.errorpage': 'Fel sida',
        'menu.profile': 'Användarinformation',
        'menu.profile.companyinfo': 'Företagsinformation',
        'languages.title': 'Språkversioner',
        'languages.info': 'Bevara innehållet i texter',
        'languages.templates': 'Meddelandemallar',
        'languages.templates.usage': 'Identifierare i meddelandemallar',
        'languages.templates.period': '- rapporteringsperiod: ',
        'languages.templates.company': '- företag: ',
        'languages.templates.deadline': '- tidsfrist för rapportering: ',
        'languages.infos': 'Instruktionstexter',
        'languages.templates.confirm': 'Rapport mottagen',
        'languages.templates.reminder': 'Påminnelse',
        'languages.templates.reminder2': 'Ytterligare påminnelse',
        'languages.templates.periodOpen': 'Rapportperiodens början',
        'languages.finnish': 'Finska',
        'languages.swedish': 'Svenska',
        'languages.english': 'Engelska',
        'languages.message.title': 'Meddelandets titel',
        'languages.message.content': 'Meddelandets innehåll',
        'languages.message.saved': 'Meddelande mall sparad',
        'languages.infotext.saved': 'Instruktionstext sparad',
        'languages.infotext.content': 'Text',
        'languages.infotexts.usage': 'Instruktionstexter på sidorna',
        'languages.infotexts.login.info.header': 'Titeln på hälsningsfrasen på inloggningssidan',
        'languages.infotexts.login.info': 'Välkommen till inloggningssidan',
        'languages.infotexts.company.info': 'Företagsinformation guide',
        'report.header': 'Månadsrapport',
        'report.header.info': 'Rapportering av importvolymer av SE-utrustning',
        'report.header.confirm.text': 'Kontrollera de ändringar du har gjort och skick den bekräftade rapporten.',
        'report.header.confirm': 'Skick bekräftade rapporten',
        'report.header.reporter': 'Reporter',
        'report.header.modified': 'Senast ändrad',
        'report.header.period': 'Period',
        'report.details.open': 'Öppna sektioner',
        'report.details.close': 'Nära sektioner',
        'report.details.sum': 'Totalt',
        'report.reference': 'Leverantörens referens',
        'report.saved': 'Rapportdata sparad',
        'report.saved.info': 'sparade rapportinformationen. Bekräfta rapporten!',
        'report.confirmed': 'Rapportdata bekräftad',
        'report.confirmed.info': 'bekräftade informationen i rapporten',
        'report.header.pricegroup': 'Prisgrupp',
        'report.header.price': 'Pris',
        'report.header.fin': 'Fastlandsfinland',
        'report.header.aland': 'Åland',
        'report.header.b2b': 'B2B',
        'report.header.fin.kg': 'Fastlandsfinland (kg)',
        'report.header.fin.pc': 'Fastlandsfinland (st)',
        'report.header.aland.kg': 'Åland (kg)',
        'report.header.aland.pc': 'Åland (st)',
        'report.header.b2b.kg': 'B2B (kg)',
        'report.header.b2b.pc': 'B2B (st)',
        'report.header.sum': 'Totalt (€)',
        'report.format.info': 'Ange siffrorna i formatet 12 345,67 (komma som decimalavgränsare). Fältet redigeras automatiskt till rätt format. ',
        'reports.reports': 'Rapporter',
        'reports.allreports': 'Alla rapporter',
        'reports.reportstatus': 'Rapporteringsstatus',
        'reports.status': 'Situation',
        'reports.lists': 'Listor',
        'reports.periods': 'Periods',
        'reports.reportedpom': 'POM rapporterad för en produktkategori ',
        'reports.companies': 'Företag',
        'reports.ongoing': 'Pågående',
        'reports.company': 'Företag',
        'reports.sum': 'Totalt',
        'reports.modified': 'Redigering av data',
        'reports.statusinfo': 'Företagets rapporteringsstatus. Du kan redigera rapporten fram till den 25:e i månaden.',
        'reports.currentperiod': 'Rapportering för innevarande period: ',
        'reports.state': 'Status',
        'reports.openreport': 'Öppna rapporten',
        'reports.addreport': 'Lägg till rapporten',
        'reports.period': 'Period',
        'reports.periodView': 'Period',
        'reports.interval': 'månader',
        'reports.intervalShort': 'mån',
        'reports.deadline': 'Tidsfrist',
        'reports.lastmodified': 'Senast ändrad',
        'reports.actions': 'Aktiviteter',
        'reports.count.bookkeeping': '{start} - {end} / {total} rapporter',
        'reports.count.companies': '{start} - {end} / {total} företag',
        'reports.count.users': '{start} - {end} / {total} användrar',
        'reports.count.reports': '{start} - {end} / {total} rapporter',
        'reports.count.eventlog': '{start} - {end} / {total} rader',
        'reports.count.ongoing': '{start} - {end} / {total} rapporter',
        'reports.count.reportedpom': '{start} - {end} / {total} rapporter',
        'reports.countonpage': 'st / sida',
        'reports.firstpage': 'Första',
        'reports.lastpage': 'Sista',
        'reports.nextpage': 'Nästa',
        'reports.previouspage': 'Tidigare',
        'reports.confirmreport': 'Bekräfta rapporten',
        'reports.obligatory.info': 'Obligatorisk information',
        'reports.subcategory.show.info': 'Öppna ytterligare information',
        'reportstatus.NEW': 'Utan start',
        'reportstatus.OVERDUE': 'Försenad',
        'reportstatus.EDITING': 'Ändrad',
        'reportstatus.ONGOING': 'Sparad',
        'reportstatus.CONFIRMED': 'Bekräftat',
        'reportstatus.CLOSED': 'Stängt',
        'reportstatus.CORRECTED': 'Rättad',
        'reportstatus.REOPENED': 'Återöppnad',
        'reportstatus.BILLED': 'Fakturerad',
        'reportstatus.REBILLED': 'Kredit fakturerad',
        'reportstatus.MISSING': 'Inget att rapportera',
        'reportedpom.statusinfo': 'reportedpom statusinfo',
        'button.reportedpom.download': 'Ladda ner',
        'reportedpom.name': 'Företag',
        'reportedpom.total_fin': 'Fastlandsfinland',
        'reportedpom.total_aland': 'Åland',
        'reportedpom.total_b2b': 'B2B',
        'reportedpom.total': 'Totalt',
        'reportedpom.period': 'Period',
        'reportedpom.unit': 'Enhet',
        'reportedpom.total_pcs': 'Totalt (st)',
        'reportedpom.total_kg': 'Totalt (kg)',
        'reportedpom.total_fin_pcs': 'Fastlandsfinland (st)',
        'reportedpom.total_fin_kg': 'Fastlandsfinland (kg)',
        'reportedpom.total_aland_pcs': 'Åland (st)',
        'reportedpom.total_aland_kg': 'Åland (kg)',
        'reportedpom.total_b2b_pcs': 'B2B (pcs)',
        'reportedpom.total_b2b_kg': 'B2B (kg)',
        'billingstatus.NEW': 'Väntar',
        'billingstatus.EDITING': 'Väntar',
        'billingstatus.ONGOING': 'Väntar',
        'billingstatus.CONFIRMED': 'Väntar',
        'billingstatus.CLOSED': 'Väntar',
        'billingstatus.CORRECTED': 'Väntar',
        'billingstatus.REOPENED': 'Väntar',
        'billingstatus.BILLED': 'Fakturerad',
        'billingstatus.REBILLED': 'Fakturerad',
        'billingstatus.invoice.corrected': 'Rättad',
        'billingstatus.invoice.refund': 'Kreditnota',
        'billingstatus.invoice.consolidated': 'Samling  ({index}/{count})',
        'bookkeeping.bookkeeping': 'Redovisning',
        'bookkeeping.statusinfo': 'Ladda ner faktureringsinformation',
        'bookkeeping.select': 'Välj',
        'bookkeeping.company': 'Företag',
        'bookkeeping.period': 'Period',
        'bookkeeping.periodView': 'Period',
        'bookkeeping.state': 'Status',
        'bookkeeping.sum': 'Totalt',
        'bookkeeping.billed': 'Fakturering',
        'bookkeeping.actions': 'Funktioner',
        'bookkeeping.currentperiod': 'Nya rapporter',
        'bookkeeping.corrected': 'Rättad',
        'bookkeeping.unbilled': 'Ej debiterad',
        'bookkeeping.sent': 'Skickas till redovisning',
        'bookkeeping.currentperiod.arialabel': 'Alla rapporter för innevarande period, {count} st, tabellen nedan filtreras av detta värde', 
        'bookkeeping.corrected.arialabel': 'Alla rättade rapporter, {count} st, tabellen nedan filtreras av detta värde', 
        'bookkeeping.unbilled.arialabel': 'Alla ej fakturerade rapporter, {count} st, tabellen nedan filtreras av detta värde', 
        'bookkeeping.sent.arialabel': 'Alla rapporter skickade till redovisning, {count} st, tabellen nedan filtreras av detta värde',
        'bookkeeping.confirm.send.invoices': 'Det tar några minuter att skicka och acceptera fakturor. Vanligen bekräfta att skicka.',
        'bookkeeping.confirm.send.invoices.title': 'Bekräfta att skicka fakturor',
        'button.bookkeeping.send': 'Skicka till redovisning (csv)',
        'button.bookkeeping.send.netvisor': 'Skicka till redovisning (NetVisor)',
        'button.bookkeeping.download': 'Ladda ner (csv)',
        'button.bookkeeping.download.netvisor': 'Ladda ner (NetVisor)',
        'bookkeeping.selected.count': '{count} rapporter valda',
        'bookkeeping.select.all': 'Välj alla',
        'bookkeeping.invoices.sent.info': '{count} fakturor skickade till redovisning',
        'tablefilters.arialabel': 'Tabellens filter och sammanfattning',
        'users.title': 'Användaradministration',
        'users.title.info': 'Underhåll användardata',
        'users.adduser': ' Lägg till användare',
        'users.title.user': 'Användare - ',
        'users.modifyuser': 'Edit',
        'users.archiveuser': 'Arkivera',
        'users.activateuser': 'Aktivera',
        'users.name': 'Namn',
        'users.email': 'E-post',
        'users.phone': 'Telefonnumm',
        'users.companies': 'Företag',
        'users.reporting': 'Rapporter',
        'users.language': 'Språk',
        'users.info': 'Meddelande',
        'users.state': 'Status',
        'users.actions': 'Aktiviteter',
        'users.active': 'Aktiv',
        'users.archived': 'Arkiverad',
        'users.activeusers': 'Aktiva användare',
        'users.reportingusers': 'Rapportörer',
        'users.infousers': 'Mottagare av meddelanden',
        'users.archivedusers': 'Arkiverad',
        'users.activeusers.arialabel': 'Alla aktiva användare, {count} st, tabellen nedan filtreras av detta värde',
        'users.reportingusers.arialabel': 'Alla reportrar, {count} st, tabellen nedan filtreras av detta värde',
        'users.infousers.arialabel': 'Alla mottagare av meddelanden, {count} st, tabellen nedan filtreras av detta värde',
        'users.archivedusers.arialabel': 'Alla arkiverade användare, {count} st, tabellen nedan filtreras av detta värde',
        'users.addUser.info': 'Spara användarinformation innan du lägger till företag.',
        'users.saved': 'Data sparad',
        'users.fail.info': 'Kontrollera informationen i formuläret.',
        'users.obligatory.info': 'Obligatorisk information',
        'users.email.error': 'E-postadress redan registrerad för användaren',
        'users.addcompany': 'Lägg till företag',
        'users.pickcompany': 'Välj företag...',
        'users.findcompany': 'Hitta ett företag',
        'users.companiestoadd': 'Företaget att lägga till',
        'users.search.text': 'Sök efter användarnamn eller e-post',
        'confirm.remove': 'Bekräfta radering',
        'confirm.remove.content': 'Vänligen bekräfta raderingen av raden.',
        'confirm.archive': 'Bekräfta arkivering',
        'confirm.archive.content': 'Vänligen bekräfta arkivering.',
        'confirm.activate': 'Bekräfta aktivering',
        'confirm.activate.content': 'Vänligen bekräfta aktivering.',
        'companies.title': 'Företagsadministration',
        'companies.title.info': 'Underhåll företagsinformation',
        'companies.search': 'Sök',
        'companies.search.text': 'Sök efter företagsnamn eller företags-ID',
        'companies.add': ' Lägg till företag',
        'companies.id': 'Internt id',
        'companies.name': 'Namn',
        'companies.bid': 'Företags-ID',
        'companies.address': 'Adress',
        'companies.postal_code': 'Postnummer',
        'companies.city': 'Stad',
        'companies.country': 'Land',
        'companies.phone': 'Telefonnummer',
        'companies.www': 'Webadress',
        'companies.archived': 'Arkiverad',
        'companies.active': 'Aktiv',
        'companies.archive_period': 'Arkiveringsperiod',
        'companies.member': 'Medlemsnummer',
        'companies.member_since': 'Anslutningsdatum',
        'companies.reporting_started': 'Börja och sluta rapportering',
        'companies.certificate': 'Certifikatnummer',
        'companies.state': 'Status',
        'companies.users': 'Användare',
        'companies.actions': 'Aktiviteter',
        'companies.modify': 'Edit',
        'companies.export.header': 'Företag',
        'companies.addUser.info': 'Spara företagsuppgifter innan du lägger till en användare.',
        'companies.saved': 'Data sparad',
        'companies.fail.info': 'Kontrollera informationen i formuläret.',
        'companies.obligatory.info': 'Obligatorisk information',
        'companies.details': 'Företagsinformation',
        'companies.invoicing': 'Faktureringsinformation',
        'companies.membership': 'Information om medlemskap',
        'companies.addedusers': 'Användare kopplade till företaget',
        'companies.adduser': 'Lägg till användare',
        'companies.finduser': 'Hitta användare',
        'companies.userstoadd': 'Användare att lägga till',
        'companies.pickuser': 'Välj användare...',
        'companies.contactinfo': 'Kontaktuppgifter',
        'companies.settings': 'Rapporteringsinställningar',
        'companies.reportingperiod': 'Rapporteringsintervall',
        'companies.reportingperiod.1': ' Månad',
        'companies.reportingperiod.3': ' En kvart',
        'companies.reportingperiod.6': ' 2 gånger/år',
        'companies.reportingperiod.12': ' År',
        'companies.billingaddress': 'Fakturaadress',
        'companies.billinglanguage': 'Standardspråk för fakturering',
        'companies.vatrate': 'Momssats',
        'companies.vatrate.0': '0%',
        'companies.vatrate.24': '24%',
        'companies.vatrate.255': '25,5% (24% tills 31.8.2024)',
        'companies.paymentterm': 'Betalningsperiod',
        'companies.paymentterm.day': 'dag',
        'companies.reference': 'Standardreferens',
        'companies.type': 'Faktureringsmetod',
        'companies.type.post': 'Post',
        'companies.type.email': 'E-post',
        'companies.type.online': 'Online faktura',
        'companies.billingemail': 'Faktura via mail (separera e-postmeddelanden med ett kommatecken)',
        'companies.onlineid': 'Operatörs-ID',
        'companies.operator': 'Operatör för e-fakturering',
        'companies.additionalinfo': 'Ytterligare information (inre)',
        'companies.inquiries': 'Förfrågningar',
        'messagelog.title': 'Meddelandehistorik',
        'messagelog.title.info': 'Visa meddelandehändelser',
        'settings.title': 'Inställningar',
        'settings.info': 'Underhåll systemets inställningar',
        'settings.accountingemail': 'E-post för fakturering',
        'settings.billinglimit': 'Minsta faktureringsgräns',
        'settings.saved': 'Inställningar sparade',
        'settings.saved.failed': 'Misslyckades med att spara inställningar',
        'settings.fail.info': 'Kontrollera informationen i formuläret.',
        'settings.obligatory.info': 'Obligatorisk information',
        'ongoing.select': 'Välj',
        'ongoing.company': 'Företag',
        'ongoing.period': 'Period',
        'ongoing.periodView': 'Period',
        'ongoing.state': 'Status',
        'ongoing.latest': 'Senaste påminnelse',
        'button.ongoing.send': 'Skicka påminnelse',
        'ongoing.all': 'Allt',
        'ongoing.current': 'Innevarande period',
        'ongoing.previous': 'Föregående period',
        'ongoing.earlier': 'Tidigare perioder',
        'ongoing.all.arialabel': 'Alla pågående rapporter, {count} st, tabellen nedan filtreras av detta värde',
        'ongoing.current.arialabel': 'Alla pågående rapporter för innevarande period, {count} st, tabellen nedan filtreras av detta värde',
        'ongoing.previous.arialabel': 'Alla pågående rapporter från föregående period, {count} st, tabellen nedan filtreras av detta värde',
        'ongoing.earlier.arialabel': 'Alla pågående rapporter från tidigare perioder, {count} st, tabellen nedan filtreras av detta värde',
        'ongoing.neversent': 'Ingen påminnelse',
        'ongoing.sent': 'Upplagt',
        'ongoing.reminders.sent.info': '{count} påminnelser skickade',
        'categories.title': 'Produktkategorier',
        'categories.title.info': 'Underhålla produktinformation',
        'categories.import.pricelist': 'Import av en prislista',
        'categories.add.category': 'Lägg till kategori',
        'categories.add.subcategory': 'Lägg till underkategori',
        'categories.category.code': 'Kategori kod',
        'categories.category.name_fi': 'FI - Kategorinamn',
        'categories.category.name_se': 'SE - Kategorinamn',
        'categories.category.name_en': 'EN - Kategorinamn',
        'categories.category.price': 'Pris',
        'categories.edit': 'Edit',
        'categories.saved': 'Data sparad',
        'categories.category': 'Kategori',
        'categories.category.select': 'Välj produktkategori',
        'categories.subcategory.title': 'Underkategorier',
        'categories.subcategory.add': 'Lägg till underkategori',
        'categories.subcategory.modify': 'Redigera underkategoridata',
        'categories.subcategory.code': 'Underkategori kod',
        'categories.subcategory.columns': 'Kolumner',
        'categories.subcategory.fin': 'Fastlandsfinland',
        'categories.subcategory.aland': 'Åland',
        'categories.subcategory.b2b': 'B2B',
        'categories.subcategory.priceunit': 'Prisenhet',
        'categories.subcategory.pricestart': 'Startdatum',
        'categories.subcategory.price': 'Pris',
        'categories.subcategory.texts': 'Underkategori texter',
        'categories.subcategory.addrow': 'Lägg till rad',
        'categories.subcategory.name': 'Namn på underkategori',
        'categories.subcategory.info': 'Instruktionstext',
        'categories.obligatory.info': 'Obligatorisk information',
    }

  };

  export default LocalizedStrings;
